import React from "react";
import Navbar from "../navbar/Navbar";
import DemoDashboard from "../demodashboard/demodashboard";
import Services from "../services/Services";
import Footer from "../footer/Footer";
import { Box } from "@mui/material";
import { motion } from "framer-motion";
import styles from "./AIAgentPage.module.css";

// Import additional components if available
import ServiceProcess from "../serviceprocess/ServiceProcess";
import Facilities from "../facilities/Facilities";
import ContextException from "../contextexception/ContextException";
import Testimonial from "../testimonials/Testimonial";
import ContactUs from "../contact/ContactUs";


const AIAgentPage = () => {
  return (
    <div className={styles.aiAgentPage}>
      
      <Navbar />
      
      {/* Hero Section */}
      <Box className={styles.aiAgentHero}>
        <div className={styles.techBg}></div>
        <div className={styles.floatingParticles}>
          {[...Array(8)].map((_, i) => (
            <div key={i} className={styles.particle}></div>
          ))}
        </div>
        
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className={styles.heroContent}
        >
          <div className={styles.heroTitleContainer}>
            <span className={styles.titleIcon}>ㅤ</span>
            <h1 className={styles.heroTitle}>
              <span className={styles.titleGradient}>ㅤ</span>
            </h1>
            <div className={styles.titleGlow}></div>
          </div>
          
          <motion.p 
            className={styles.heroDescription}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3, duration: 0.8 }}
          >
            Discover our advanced AI agents designed to transform your workflows, 
            automate complex tasks, and deliver intelligent solutions across industries. 
            From healthcare to education, our neural AI models provide real-time, 
            context-aware assistance.
          </motion.p>
          
          <motion.div 
            className={styles.statsContainer}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5, duration: 0.8 }}
          >
            <div className={styles.statItem}>
              <span className={styles.statNumber}>10+</span>
              <span className={styles.statLabel}>AI Bots</span>
            </div>
            <div className={styles.statItem}>
              <span className={styles.statNumber}>24/7</span>
              <span className={styles.statLabel}>Uptime</span>
            </div>
            <div className={styles.statItem}>
              <span className={styles.statNumber}>99.9%</span>
              <span className={styles.statLabel}>Accuracy</span>
            </div>
            <div className={styles.statItem}>
              <span className={styles.statNumber}>10K+</span>
              <span className={styles.statLabel}>Users</span>
            </div>
          </motion.div>
        </motion.div>
        
        <div className={styles.scanLine}></div>
        
        {/* Connection Dots */}
        
      </Box>

      
      

     
     
      
     
      {/* Bottom Tech Elements */}
      <Box className={styles.bottomTechElements}>
      </Box>
      <DemoDashboard />
      <Services />
      <Testimonial />
      <ContactUs />
      <Footer />
    </div>
  );
};

export default AIAgentPage;